import styles from './ProgressPopup.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

interface ProgressPopupProps {
   title: string
   done: number
   total: number
}

/** Popup statique de progression (lecture seule) — pas d'action utilisateur. */
function ProgressPopup({ title, done, total }: ProgressPopupProps) {
   const pct = total > 0 ? Math.min(100, Math.round((100 * done) / total)) : 0
   return (
      <div className={styles.background}>
         <div className={styles.progress_popup}>
            <div className={styles.title}>
               <FontAwesomeIcon icon={faSpinner} spin />
               <span>{title}</span>
            </div>
            <div className={styles.counter}>{done} / {total}</div>
            <div className={styles.bar}>
               <div className={styles.fill} style={{ width: `${pct}%` }} />
            </div>
         </div>
      </div>
   )
}

export default ProgressPopup
